import { OrderAhead } from "./interfaces";

export const getDefaultState = (): OrderAhead => {
  return {
    selectedPickup: null, // null for "now" or datetime ISO8601
    activeVendorId: null
  };
};

export const state = getDefaultState();
